import React from "react";
import { Image, View, SafeAreaView, StyleSheet, TextInput, Button } from "react-native";
import { getAuth, setPersistence, signInWithEmailAndPassword, browserSessionPersistence } from "firebase/auth";
import firebase from '../firebase/Config';

const LoginScreen = props => {

  const [email, onChangeEmail] = React.useState("");
  const [password, onChangePassword] = React.useState("");

  firebase.auth().onAuthStateChanged(function (user) {
    if (user) {
      props.navigation.navigate('ChooseArtistScreen')
    }
  });

  function handleClick() {
    const auth = getAuth();
    setPersistence(auth, browserSessionPersistence)
      .then(() => {
        return signInWithEmailAndPassword(auth, email, password);
      })
      .catch((error) => {
        const errorCode = error.code;
        if (errorCode == "auth/wrong-password") {
          alert("Incorrect password.");
        } else if (errorCode == "auth/invalid-email") {
          alert("Incorrect email.");
        } else if (errorCode == "auth/too-many-requests") {
          alert("Too many incorrect password attempts. Please try again later.");
        }
      });
  }

  return (
    <SafeAreaView style={styles.inputView}>
      <Image
        style={styles.logo}
        source={require('../public/imgs/demodeck.png')}
      />
      <TextInput
        style={styles.input}
        onChangeText={newEmail => onChangeEmail(newEmail)}
        value={email}
        placeholder="Email"
        keyboardType="email-address"
      />
      <TextInput
        style={styles.input}
        onChangeText={newPassword => onChangePassword(newPassword)}
        value={password}
        placeholder="Password"
        keyboardType="default"
        color="white"
        secureTextEntry="true"
      />
      <View style={styles.buttonView}>
        <Button
          onPress={handleClick}
          title="Log In"
          color="#3498DB"
        />
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  inputView: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1
  },
  logo: {
    height: 25,
    width: 270,
    margin: 30
  },
  input: {
    height: 40,
    width: 250,
    margin: 5,
    padding: 15,
    backgroundColor: "#232323",
    borderRadius: 8,
    color: "white"
  },
  buttonView: {
    margin: 15
  }
});

export default LoginScreen;
